module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_26_LICZEBNIKI_7_B.8d416dd3.mp3";